import { render, staticRenderFns } from "./xcrw.vue?vue&type=template&id=72d954ba&scoped=true&"
import script from "./xcrw.vue?vue&type=script&lang=js&"
export * from "./xcrw.vue?vue&type=script&lang=js&"
import style0 from "./xcrw.vue?vue&type=style&index=0&id=72d954ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d954ba",
  null
  
)

export default component.exports